export const CODE_BACKSPACE = 'Backspace'
export const CODE_BREAK = 19
export const CODE_DELETE = 46
export const CODE_DOWN = 'ArrowDown'
export const CODE_END = 'End'
export const CODE_ENTER = 13
export const CODE_ESC = 27
export const CODE_HOME = 'Home'
export const CODE_LEFT = 'ArrowLeft'
export const CODE_PAGEDOWN = 'PageDown'
export const CODE_PAGEUP = 'PageUp'
export const CODE_RIGHT = 'ArrowRight'
export const CODE_SPACE = 32
export const CODE_UP = 'ArrowUp'

export const RX_UNDERSCORE = /_/g
export const RX_LOWER_UPPER = /([a-z])([A-Z])/g
export const RX_NUMBER = /^[0-9]*\.?[0-9]+$/
export const RX_START_SPACE_WORD = /(\s|^)(\w)/g
export const RX_FIRST_START_SPACE_WORD = /(\s|^)(\w)/
export const RX_SPACE_SPLIT = /\s+/
export const RX_HASH = /^#/
export const RX_HASH_ID = /^#[A-Za-z]+[\w\-:.]*$/

export const RX_STRIP_LOCALE_MODS = /-u-.+/
export const RX_REGEXP_REPLACE = /[-/\\^$*+?.()|[\]{}]/g
export const RX_SPACES = /[\s\uFEFF\xA0]+/g
